import { ButtonSize, ButtonVariants } from '@anm/components/buttons/Button';
import Confirm from '@anm/components/notification/Confirm';
import useHover from '@anm/hooks/useHover';
import { FC } from 'react';

export type ConfirmDeleteProps = {
  title?: string;
  isPending?: boolean;
  description?: string;
  deleteItemName?: string;
  rightButtonText?: string;
  onClose?: () => void;
  onDelete?: () => void;
};

const ConfirmDelete: FC<ConfirmDeleteProps> = ({
  deleteItemName,
  isPending = false,
  rightButtonText = 'Delete',
  title = `Delete ${deleteItemName}`,
  description = `Are you sure you want to delete this ${deleteItemName}?`,
  onClose,
  onDelete
}) => {
  const [hoverRef, isHovered] = useHover<HTMLDivElement>();

  return (
    <Confirm
      {...{ title }}
      buttonLeft={{
        text: 'Cancel',
        size: 'upper-medium' as ButtonSize,
        variant: 'blue-heavy-border' as ButtonVariants
      }}
      buttonRight={{
        isPending,
        ref: hoverRef,
        text: rightButtonText,
        size: 'upper-medium' as ButtonSize,
        color: isHovered ? 'white' : 'red',
        variant: 'red' as ButtonVariants
      }}
      onLeftButtonClick={onClose}
      onRightButtonClick={onDelete}
    >
      {description}
    </Confirm>
  );
};

export default ConfirmDelete;
